module.exports = __webpack_public_path__ + "db20b2d37bd93671e5a23e3f7ef24faa.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/avatars/uliks.jpg
// module id = 42
// module chunks = 0